import React, { useEffect } from 'react';

const Disclaimer = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">Disclaimer</h1>
                <div className="content">
                    <p>The information provided by <strong>Paymond Services Private Limited</strong> on <strong>https://Paymond.in</strong> is for general informational purposes only. All information on the Site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.</p>

                    <h3>External Links Disclaimer</h3>
                    <p>The Site may contain links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.</p>

                    <h3>Professional Disclaimer</h3>
                    <p>The Site cannot and does not contain fashion or legal advice. The fashion information is provided for general informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals.</p>

                    <h3>Limitation of Liability</h3>
                    <p>Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.</p>

                    <h3>Contact Us</h3>
                    <p>If you have any questions about this Disclaimer, please contact us at: <strong>paymondtechnologies@gmail.com</strong></p>
                </div>
            </div>
        </section>
    );
};

export default Disclaimer;
